export default __webpack_public_path__ + "static/media/AntyLucy_4.bd59c185.jpg";